import { DatePicker } from '@mui/x-date-pickers';
import { Box, TextField } from '@mui/material';
import { useState } from 'react';
import Budget from '../../object/Budget';
import Utils from 'src/commun/Utils';
import { useEffect } from 'react';
import BasePrice from 'src/object/BasePrice';

export interface IEndDeliveryInputProps {
    budget: Budget;
    basePrice: BasePrice;
}

export const EndDeliveryInput = (props: IEndDeliveryInputProps) => {
    const { budget, basePrice } = props;

    const [val, setVal] = useState(budget.livraison_date_end.get() ?? null);
    useEffect(() => {
        setVal(budget.livraison_date_end.get() ?? null);
    }, [budget.getAjoIdentifier()]);
    return (
        <Box>
            <DatePicker
                className="flex-1"
                onFocus={() => {
                    budget.getFocus();
                }}
                inputFormat="DD/MM/YYYY"
                renderInput={(params: any) => {
                    return (
                        <TextField
                            variant="outlined"
                            onClick={(e: Event) => {
                                e.stopPropagation();
                            }}
                            {...params}
                            disabled={budget.bon_commande.get() !== null || !basePrice.canAct()}
                            tabIndex={-1}
                            onBlur={() => {
                                if (budget.livraison_date_end.get() === null) {
                                    budget.addEdit({
                                        livraison_date_end: budget.livraison_date_end.get(),
                                    });
                                } else {
                                    budget.addEdit({
                                        livraison_date_end: Utils.isoString(new Date(budget.livraison_date_end.get())),
                                    });
                                }
                            }}
                            className="bg-gray-300 w-48 placeholder:text-gray-600 !border-gray-600 border rounded-lg py-2 px-3 focus:!border focus:!ring focus:!ring-blue-500 focus:!border-blue-500"
                        />
                    );
                }}
                onChange={(e: any) => {
                    let newVal;
                    if (e !== null) {
                        newVal = (e as any).toDate();
                        newVal.setTime(newVal.getTime() - newVal.getTimezoneOffset() * 60 * 1000);
                        try {
                            budget.addEdit({
                                livraison_date_end: newVal.toISOString(),
                            });
                            setVal(newVal);
                        } catch (e) {}
                    } else {
                        newVal = null;
                        budget.addEdit({
                            livraison_date_end: '',
                        });
                        setVal(newVal);
                    }
                    budget.livraison_date_end.set(newVal);
                }}
                value={val}
            />
        </Box>
    );
};
